module.exports = __webpack_public_path__ + "static/Uber_Logo_Black.fdf3a90e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team-logos/Uber_Logo_Black.png
// module id = 521
// module chunks = 35783957827783